(() => {
  const root = document.querySelector('[data-sxt-flash-offer]');
  if (!root || /\/cart|\/checkout/.test(location.pathname)) return;

  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const endpoint = String(root.dataset.endpoint || '/apps/sxt-offer').replace(/\/+$/, '');
  const frequencyMs = Math.max(1, Number(root.dataset.frequency || 24)) * 36e5;
  const dismissedAt = Number(localStorage.getItem('sxtOfferDismissedAt') || 0);
  if (Date.now() - dismissedAt < frequencyMs) return;

  const sessionKey = 'sxtTimedOfferSessionV32';
  const createSession = () => {
    const bytes = new Uint8Array(18);
    crypto.getRandomValues(bytes);
    return [...bytes].map((byte) => byte.toString(36).padStart(2, '0')).join('');
  };
  let session = localStorage.getItem(sessionKey);
  if (!/^[A-Za-z0-9_-]{20,120}$/.test(session || '')) {
    session = createSession();
    localStorage.setItem(sessionKey, session);
  }

  const claim = root.querySelector('[data-offer-claim]');
  const apply = root.querySelector('[data-offer-apply]');
  const copy = root.querySelector('[data-offer-copy]');
  const codeNode = root.querySelector('[data-offer-code]');
  const intro = root.querySelector('[data-offer-intro]');
  const message = root.querySelector('[data-offer-message]');
  const timer = root.querySelector('[data-offer-timer]');
  const mini = root.querySelector('[data-offer-mini]');
  const miniTimer = root.querySelector('[data-offer-mini-timer]');
  const toggle = root.querySelector('[data-offer-toggle]');
  const initialClaimText = claim.textContent;
  const initialMinutes = Math.max(1, Number(root.dataset.minutes || 10));
  const collapsedKey = 'sxtOfferCollapsedV34';

  const applyCollapsedState = (collapsed) => {
    root.classList.toggle('is-collapsed', collapsed);
    toggle.textContent = collapsed ? '\u2304' : '\u2303';
  };

  applyCollapsedState(sessionStorage.getItem(collapsedKey) === '1');

  let end = 0;
  let serverOffset = 0;
  let activeCode = '';
  let interval;

  const dismiss = (remember = true) => {
    root.hidden = true;
    if (remember) localStorage.setItem('sxtOfferDismissedAt', String(Date.now()));
    clearInterval(interval);
  };

  const setMessage = (bg, en) => {
    message.textContent = isEnglish ? en : bg;
  };

  const expired = () => {
    clearInterval(interval);
    end = 0;
    activeCode = '';
    root.classList.remove('is-loading');
    root.classList.add('is-expired');
    timer.textContent = '00:00';
    miniTimer.textContent = '00:00';
    claim.hidden = true;
    apply.hidden = true;
    copy.hidden = true;
    intro.textContent = isEnglish ? 'This personal offer has expired.' : 'Тази лична оферта изтече.';
    setMessage('Shopify вече няма да приеме този код.', 'Shopify will no longer accept this code.');
    localStorage.setItem('sxtOfferDismissedAt', String(Date.now()));
    window.setTimeout(() => dismiss(false), 7000);
  };

  const tick = () => {
    const left = Math.max(0, end - (Date.now() + serverOffset));
    const mins = Math.floor(left / 60000);
    const secs = Math.floor((left % 60000) / 1000);
    const displayTime = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    timer.textContent = displayTime;
    miniTimer.textContent = displayTime;
    if (!left) expired();
  };

  const showAvailable = () => {
    root.classList.remove('is-loading', 'is-active', 'is-expired');
    claim.hidden = false;
    claim.disabled = false;
    claim.textContent = initialClaimText;
    apply.hidden = true;
    copy.hidden = true;
    timer.textContent = `${String(initialMinutes).padStart(2, '0')}:00`;
    miniTimer.textContent = `${String(initialMinutes).padStart(2, '0')}:00`;
    setMessage('Кодът се генерира защитено от Shopify.', 'The code is generated securely by Shopify.');
    root.hidden = false;
  };

  const showActive = (data) => {
    const parsedEnd = Date.parse(data.expiresAt);
    const parsedServerNow = Date.parse(data.serverNow);
    if (!data.code || !Number.isFinite(parsedEnd)) {
      expired();
      return;
    }

    activeCode = data.code;
    end = parsedEnd;
    serverOffset = Number.isFinite(parsedServerNow) ? parsedServerNow - Date.now() : 0;
    root.classList.remove('is-loading', 'is-expired');
    root.classList.add('is-active');
    root.hidden = false;
    claim.hidden = true;
    apply.hidden = false;
    copy.hidden = false;
    codeNode.textContent = activeCode;
    apply.href = `/discount/${encodeURIComponent(activeCode)}?redirect=/collections/all`;
    intro.textContent = isEnglish
      ? 'Your unique code is active. Complete your order before the timer reaches zero.'
      : 'Уникалният Ви код е активен. Завършете поръчката преди таймерът да достигне нула.';
    setMessage('Еднократна употреба · валидира се от Shopify.', 'Single use · validated by Shopify.');
    clearInterval(interval);
    tick();
    interval = setInterval(tick, 1000);
  };

  const requestState = async (action, method = 'GET') => {
    const options = {
      method,
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { accept: 'application/json' }
    };
    let url = `${endpoint}/${action}`;
    if (method === 'POST') {
      options.headers['content-type'] = 'application/json';
      options.body = JSON.stringify({ session });
    } else {
      url += `?session=${encodeURIComponent(session)}`;
    }
    const response = await fetch(url, options);
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || `HTTP ${response.status}`);
    return data;
  };

  const waitForActive = async () => {
    for (let attempt = 0; attempt < 12; attempt += 1) {
      await new Promise((resolve) => window.setTimeout(resolve, 500));
      const status = await requestState('status');
      if (status.state === 'active') return status;
      if (status.state !== 'pending') return status;
    }
    return { state: 'error' };
  };

  claim.addEventListener('click', async () => {
    if (claim.disabled) return;
    claim.disabled = true;
    root.classList.add('is-loading');
    claim.textContent = isEnglish ? 'ACTIVATING…' : 'АКТИВИРАМЕ…';
    setMessage('Създаваме Вашия уникален код…', 'Creating your unique code…');

    try {
      let state = await requestState('claim', 'POST');
      if (state.state === 'pending') state = await waitForActive();
      if (state.state === 'active') {
        showActive(state);
        return;
      }
      if (state.state === 'expired' || state.state === 'blocked') {
        expired();
        return;
      }
      throw new Error('offer_unavailable');
    } catch (error) {
      console.error('SXT timed offer:', error);
      root.classList.remove('is-loading');
      claim.disabled = false;
      claim.textContent = isEnglish ? 'TRY AGAIN' : 'ОПИТАЙТЕ ОТНОВО';
      setMessage('Временен проблем. Моля, опитайте отново.', 'Temporary problem. Please try again.');
    }
  });

  root.querySelector('[data-offer-close]').addEventListener('click', dismiss);
  toggle.addEventListener('click', () => {
    const collapsed = !root.classList.contains('is-collapsed');
    applyCollapsedState(collapsed);
    sessionStorage.setItem(collapsedKey, collapsed ? '1' : '0');
  });
  mini.addEventListener('click', () => {
    applyCollapsedState(false);
    sessionStorage.setItem(collapsedKey, '0');
  });
  copy.addEventListener('click', async () => {
    if (!activeCode) return;
    try {
      await navigator.clipboard.writeText(activeCode);
      copy.innerHTML = isEnglish
        ? `Code copied ✓ <b>${activeCode}</b>`
        : `Кодът е копиран ✓ <b>${activeCode}</b>`;
    } catch (_) {
      setMessage('Маркирайте и копирайте показания код.', 'Select and copy the displayed code.');
    }
  });

  const initialize = async () => {
    try {
      const state = await requestState('status');
      if (state.state === 'active') {
        showActive(state);
        return;
      }
      if (state.state !== 'available') return;
      const delay = 7000 + Math.floor(Math.random() * 6000);
      window.setTimeout(showAvailable, delay);
    } catch (error) {
      console.warn('SXT timed offer is not connected yet:', error);
    }
  };

  initialize();
})();
